import * as React from 'react';

interface IFieldsetProps {
  legend: string;
  disabled?: boolean;
}

export const Fieldset = ({ legend, children, disabled = false }: React.PropsWithChildren<IFieldsetProps>) => {
  return <fieldset className="form-section" disabled={disabled}>
    <legend>{legend}</legend>
    {children}
  </fieldset>;
};
